import { CheckCircleIcon, ClockIcon, YearEndIcon } from "./DashboardIcons";

import { DashboardCard } from "./DashboardCard";
// ===== CHANGED FILE (was part of RecordsAndYearEndCard.tsx, now split
// into its own full card): Year-End Compliance (copy this whole file) =====
import { YearEndComplianceData } from "../dashboardOverview.types";

export interface YearEndComplianceCardProps {
	data: YearEndComplianceData;
	onContinue?: () => void;
}

export const YearEndComplianceCard = ({ data, onContinue }: YearEndComplianceCardProps) => {
	return (
		<DashboardCard testId="year-end-compliance-card">
			<div className="cd-card__header">
				<div className="cd-card__title">
					<YearEndIcon />
					<h2>Year-end compliance {data.taxYear}</h2>
				</div>
				<span className="cd-year-end-percent">{data.percentComplete}%</span>
			</div>
			<p className="cd-card__subtitle">{data.dueDateLabel}</p>

			<div className="cd-progress-bar">
				<div className="cd-progress-bar__fill" style={{ width: `${data.percentComplete}%` }} />
			</div>

			<div className="cd-year-end__checklist">
				{data.checklist.map((item) => (
					<div
						className={`cd-year-end__checklist-item${item.done ? " cd-year-end__checklist-item--done" : ""}`}
						key={item.id}
					>
						{item.done ? <CheckCircleIcon className="cd-icon--success" /> : <ClockIcon className="cd-icon--muted" />}
						<span>{item.label}</span>
						{item.automated && <span className="cd-badge cd-badge--success">Automated</span>}
					</div>
				))}
			</div>

			<button type="button" className="cd-secondary-button cd-year-end__continue" onClick={onContinue}>
				Continue checklist
			</button>
		</DashboardCard>
	);
};
